<template>
  <li
    ref="rootEl"
    :class="classes"
  >
    <div :class="$style.contentContainer">
      <slot name="default" />

      <div :class="$style.beforeInfo">
        <slot name="beforeInfo" />
      </div>
      <!-- holds the info block's space while it is pinned -->
      <div
        ref="placeholderEl"
        :class="$style.infoSlot"
        :style="placeholderStyle"
      >
        <div
          ref="infoEl"
          :class="{
            [$style.info]: true,
            [$style.infoFloating]: isFloating
          }"
          :style="infoStyle"
          @dblclick="scrollToCard"
        >
          <slot name="info">
            <component
              :is="to ? 'router-link' : 'div'"
              v-bind="to ? { to } : {}"
              target="_blank"
              :class="$style.description"
            >
              <div
                :class="$style.statusTitle"
                data-qa="status"
              >
                <slot name="caption" />
              </div>
              <slot name="description" />
            </component>
          </slot>

          <slot name="actions" />
        </div>
      </div>
      <slot name="misc" />
    </div>
    <div
      :class="{
        [$style.bottom]: true,
        [$style.bottomCompact]: compactBottom

      }"
    >
      <slot name="bottom" />
    </div>
  </li>
</template>

<script>
import { computed } from 'vue';
import { useFloatingInfo } from './use-floating-info';

export default {
  name: 'ApplicantVacancyItemLayout',
  props: {
    irrelevant: Boolean,
    compactBottom: {
      type: Boolean,
      default: false
    },
    to: {
      type: [Object, String],
      default: null
    },
    // keeps the info block at the top of the viewport once the card is scrolled past
    floatingInfo: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    return useFloatingInfo(computed(() => props.floatingInfo));
  },
  computed: {
    classes() {
      return {
        [this.$style.root]: true,
        [this.$style.irrelevant]: this.irrelevant
      };
    }
  }
};
</script>

<style module>
.root {
  list-style: none;
  background: #fffdec;

  --lock-icon-color: #fffdec;
  --log-background-color: #fffdec;
  border-radius: 16px;
  position: relative;
  padding-left: 4px;
}

.root,
.infoFloating {
  &::before {
    content: '';
    position: absolute;
    height: 100%;
    left: 0;
    top: 0;
    bottom: 0;
    width: 16px;
    background-image: linear-gradient(#7ac015, #7ac015);
    background-size: 4px 100%;
    background-repeat: no-repeat;
    border-radius: 16px 0 0 16px;
  }
}

.contentContainer {
  padding: 24px 24px 0 24px;
}

.irrelevant {
  background-color: #f3f4f5;
  --lock-icon-color: #f3f4f5;
  --log-background-color: #f3f4f5;
  &::before {
    background-image: linear-gradient($gray-300, $gray-300);
  }
}

.root {
  --underline-color: rgba(112, 182, 11, 0.3);

  &.irrelevant {
    --underline-color: $black-30;
  }
}

.root > .contentContainer > .infoSlot > .info .description {
  color: $green-600;
  &:hover {
    color: var(--hf-color-base-green-500);
  }
}

.root.irrelevant > .contentContainer > .infoSlot > .info .description {
  color: #969a9e;
  &:hover {
    color: #ABADB0;
  }
}

.root + .root {
  margin-top: 30px;
}

.info {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  column-gap: 16px;
}

/* Offsets and horizontal padding come from the composable — see `useFloatingInfo`. */
.infoFloating {
  position: fixed;
  z-index: 2;
  padding-top: 12px;
  padding-bottom: 12px;
  /* double click is the shortcut back to the card, not a word selection */
  user-select: none;
  background-color: var(--log-background-color);
  border-radius: 16px;
  box-shadow: 0 0 40px 0 rgba(5, 5, 5, 0.16);
}

.description {
  display: block;
  flex: 1;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  overflow: hidden;
  text-decoration: none;
}

.statusTitle {
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
}

.contentContainer + .bottom:not(:empty) {
  min-height: 48px;
}
.bottom {
  margin-top: 24px;
}

.bottomCompact {
  margin-top: 0;
}
</style>

<i18n lang="json">{}</i18n>
